/* ============================================================
   6zero – Etapa 4: menu lateral, barra de anúncios e "Atendimento"
   acessíveis pelo teclado (22/10/2026).
   Não altera o theme.js: só complementa o que ele já faz.
   ============================================================ */
(function () {
  'use strict';

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, summary, [tabindex]:not([tabindex="-1"])';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function focusables(root) {
    return Array.prototype.filter.call(root.querySelectorAll(FOCUSABLE), function (el) {
      return !el.closest('[inert]') && el.getClientRects().length > 0;
    });
  }

  function focusLater(el) {
    if (el) setTimeout(function () { el.focus({ preventScroll: true }); }, 80);
  }

  /* ----------------------------------------------------------
     i27 · i28 · i29 — Menu lateral (celular e tablet)
     - Ao abrir: o foco vai para "Fechar menu" e o Tab fica preso no menu.
     - Esc fecha o submenu aberto; com nenhum submenu aberto, fecha o menu.
     - Ao fechar: o foco volta para o botão "Menu".
     - Menu fechado e submenus fechados saem da ordem do Tab (inert).
     - Botão "Menu" e itens com submenu informam se estão abertos (aria-expanded).
     ---------------------------------------------------------- */
  function setupDrawer() {
    var nav = document.querySelector('.mobile-navigation');
    if (!nav) return;
    var drawer = nav.querySelector('.mobile-navigation__drawer');
    var closeBtn = nav.querySelector('#navigationDrawerClose');
    var backBtn = nav.querySelector('.btn-back');
    var extras = nav.querySelectorAll('.mobile-navigation__localization, .mobile-navigation__secondary-menu');
    var toggles = Array.prototype.slice.call(document.querySelectorAll('.mobile-navigation__toggle'));
    if (!drawer || !closeBtn) return;

    drawer.id = drawer.id || 'menu-lateral';
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('aria-label', 'Menu');

    var lastToggle = null;
    toggles.forEach(function (t) {
      t.setAttribute('aria-expanded', 'false');
      t.setAttribute('aria-controls', drawer.id);
      t.addEventListener('click', function () { lastToggle = t; });
    });

    var items = Array.prototype.slice.call(nav.querySelectorAll('.mobile-navigation__level-1 > li'));
    items.forEach(function (li, i) {
      // O <li> era focável à toa (tabindex="0"): uma parada extra de Tab sem função.
      if (li.getAttribute('tabindex') === '0') li.removeAttribute('tabindex');
      var panel = li.querySelector('.mobile-navigation__level-2');
      var link = li.querySelector('.menu-level-1 > a');
      var innerBtn = li.querySelector('.mobile-navigation__level-2-toggle');
      if (panel && link) {
        panel.id = panel.id || 'submenu-' + (i + 1);
        link.setAttribute('aria-expanded', 'false');
        link.setAttribute('aria-controls', panel.id);
        // A seta fica dentro do link e faz a mesma coisa que ele: sai do Tab.
        if (innerBtn) {
          innerBtn.setAttribute('tabindex', '-1');
          innerBtn.setAttribute('aria-hidden', 'true');
        }
      }
    });

    function isOpen() { return drawer.classList.contains('translate-left-center'); }
    function openPanel() { return nav.querySelector('.mobile-navigation__level-2.translate-left-center'); }

    function sync() {
      var open = isOpen();
      var panel = openPanel();
      drawer.inert = !open;
      toggles.forEach(function (t) { t.setAttribute('aria-expanded', String(open)); });
      items.forEach(function (li) {
        var p = li.querySelector('.mobile-navigation__level-2');
        var link = li.querySelector('.menu-level-1 > a');
        var row = li.querySelector('.menu-level-1');
        if (p) p.inert = p !== panel;
        if (p && link) link.setAttribute('aria-expanded', String(p === panel));
        if (row) row.inert = !!panel;
      });
      Array.prototype.forEach.call(extras, function (el) { el.inert = !!panel; });
      if (backBtn) {
        backBtn.inert = !panel;
        backBtn.setAttribute('aria-hidden', String(!panel));
      }
    }

    var wasOpen = isOpen();
    var wasPanel = openPanel();
    sync();

    new MutationObserver(function () {
      var open = isOpen();
      var panel = openPanel();
      if (open === wasOpen && panel === wasPanel) return;
      sync();
      if (open && !wasOpen) focusLater(closeBtn);
      if (!open && wasOpen) {
        var t = lastToggle || toggles.filter(function (x) { return x.getClientRects().length; })[0];
        focusLater(t);
      }
      if (open && panel && panel !== wasPanel) focusLater(focusables(panel)[0] || backBtn);
      if (open && !panel && wasPanel) {
        var li = wasPanel.closest('li');
        focusLater(li && li.querySelector('.menu-level-1 > a'));
      }
      wasOpen = open;
      wasPanel = panel;
    }).observe(nav, { subtree: true, attributes: true, attributeFilter: ['class'] });

    document.addEventListener('keydown', function (e) {
      if (!isOpen()) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        if (openPanel() && backBtn) backBtn.click();
        else closeBtn.click();
        return;
      }
      if (e.key !== 'Tab') return;
      var list = focusables(drawer);
      if (!list.length) return;
      var first = list[0];
      var last = list[list.length - 1];
      if (!drawer.contains(document.activeElement)) {
        e.preventDefault();
        first.focus();
      } else if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  }

  /* ----------------------------------------------------------
     i30 — Barra de anúncios: para de trocar sozinha.
     A troca automática a cada 5 s não tinha como ser pausada
     (WCAG 2.2.2). As setas continuam funcionando.
     Para voltar a girar, troque GIRAR_ANUNCIOS para true:
     aí ela pausa com o mouse, com o foco e com "reduzir movimento".
     ---------------------------------------------------------- */
  var GIRAR_ANUNCIOS = false;

  function setupAnnouncement() {
    var container = document.querySelector('.announcement-bar .swiper-container');
    if (!container) return;
    var tries = 0;
    (function wait() {
      var sw = container.swiper;
      if (!sw || !sw.autoplay) {
        if (tries++ < 60) setTimeout(wait, 100);
        return;
      }
      // O Swiper põe "Previous slide"/"Next slide" ao iniciar; troca depois dele.
      if (sw.params && sw.params.a11y) {
        sw.params.a11y.prevSlideMessage = 'Anúncio anterior';
        sw.params.a11y.nextSlideMessage = 'Próximo anúncio';
      }
      nomearSetas();
      setTimeout(nomearSetas, 500);
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!GIRAR_ANUNCIOS || reduce) {
        sw.autoplay.stop();
        return;
      }
      function stop() { if (sw.autoplay.running) sw.autoplay.stop(); }
      function start() { if (!sw.autoplay.running) sw.autoplay.start(); }
      container.addEventListener('mouseenter', stop);
      container.addEventListener('mouseleave', start);
      container.addEventListener('focusin', stop);
      container.addEventListener('focusout', function (e) {
        if (!container.contains(e.relatedTarget)) start();
      });
    })();

    // As setas não tinham nome em português.
    function nomearSetas() {
      var prev = container.querySelector('.swiper-button-prev');
      var next = container.querySelector('.swiper-button-next');
      if (prev) prev.setAttribute('aria-label', 'Anúncio anterior');
      if (next) next.setAttribute('aria-label', 'Próximo anúncio');
    }
    nomearSetas();
  }

  /* ----------------------------------------------------------
     Extra — "Atendimento" no topo só abria com o mouse.
     Agora abre com Tab + Enter/Espaço e fecha com Esc.
     ---------------------------------------------------------- */
  function setupContact() {
    var wrap = document.querySelector('.announcement-contact-wrapper');
    if (!wrap) return;
    var toggle = wrap.querySelector('.announcement-contact-toggle');
    var dropdown = wrap.querySelector('.announcement-contact-dropdown');
    if (!toggle || !dropdown) return;
    dropdown.id = dropdown.id || 'atendimento-opcoes';
    toggle.setAttribute('role', 'button');
    toggle.setAttribute('tabindex', '0');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-controls', dropdown.id);

    function set(open) {
      wrap.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', String(open));
    }
    toggle.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        set(!wrap.classList.contains('is-open'));
        if (wrap.classList.contains('is-open')) focusLater(focusables(dropdown)[0]);
      }
    });
    wrap.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && wrap.classList.contains('is-open')) {
        set(false);
        toggle.focus();
      }
    });
    wrap.addEventListener('focusout', function (e) {
      if (!wrap.contains(e.relatedTarget)) set(false);
    });
  }

  ready(function () {
    setupDrawer();
    setupAnnouncement();
    setupContact();
  });
})();
